import { AlertColorType, Icon } from "@/lib/main";
import { OutlineAlertIconNameType } from "@/lib/types/graphics/icons/IconName.type";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLDivElement>["className"];
  color: AlertColorType;
  icon: OutlineAlertIconNameType;
  justifyContent?: CSSProperties["justifyContent"];
  style?: CSSProperties;
}>;

export default function AlertCaption({
  children,
  className,
  color,
  icon,
  justifyContent = "flex-start",
  style,
}: Props) {
  return (
    <div
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent,
        columnGap: "var(--spacing-xs)",
        ...style,
      }}
    >
      <Icon name={icon} color={color} size="md" />
      <p
        style={{
          color: `var(--color-text-${color})`,
          fontSize: `var(--font-size-2xs)`,
          fontWeight: 400,
        }}
      >
        {children}
      </p>
    </div>
  );
}
